import React, { useMemo } from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { ICompetitionRankingsChangedActivity } from './interfaces';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { RankingTable } from '@pages/Portal/Competitions/components/RankingTable';
import { mapRankingEntryToRankingItem } from './helpers';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';
import { getPortalCompetitionDetailsRoute } from '../helpers';
import { getRankingValueColumnLabel } from '@pages/Portal/Competitions/helpers';
import { useAuth } from '@context/AuthProvider';

export const CompetitionRankingsChangedActivity: React.FC<
  ICompetitionRankingsChangedActivity
> = (props): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { currentUser } = useAuth();
  const highlightedMemberSlug = currentUser?.member?.slug;

  const detailsRoute = getPortalCompetitionDetailsRoute(props.slug, props.status);

  const rankingItems = useMemo(
    () => props.ranking.map(mapRankingEntryToRankingItem),
    [props.ranking]
  );

  const scoreColumnLabel = getRankingValueColumnLabel(
    props.scoreUnit,
    props.rankingMethod
  );

  const title = (
    <Trans
      i18nKey={'activities:competitionRankingsChanged.title'}
      values={{
        title: props.title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={title}
      date={props.date}
      icon={EmojiEventsIcon}
      onClick={() => navigate(detailsRoute)}
    >
      <RankingTable
        rankingData={rankingItems}
        scoreColumnLabel={scoreColumnLabel}
        minCountingScores={props.minCountingScores}
        disableColumnSorting
        highlightedMemberSlug={highlightedMemberSlug}
      />
      <Button onClick={() => navigate(detailsRoute)}>
        <Trans i18nKey={'activities:competitionRankingsChanged.viewAll'} />
      </Button>
    </ActivityPost>
  );
};
